export const DEFAULT_LIMIT_AUCTION_DURATION = 60;
